import MatrixBarGraph from './MatrixBarGraph';
import React, { Component } from 'react';

class MatrixInfoPanel extends Component {
    render() {
        const { devicesShowing, zonesShowing, triggerCounts, showSinglePercentage, testInstance } = this.props;

        const selectedDevice = devicesShowing.find(({ isSelected }) => isSelected);
        const selectedZone = zonesShowing.find(({ isSelected }) => isSelected);

        let stats, chart;

        if (selectedDevice) {
            const chartData = triggerCounts.device[selectedDevice._id];

            stats = [
                <tr key="stats-single-row">
                    <td key="stats-single">Single</td>
                    <td key="stats-single-count">{triggerCounts.device[selectedDevice._id].single}</td>
                </tr>,
                <tr key="stats-over-row">
                    <td key="stats-over">Over</td>
                    <td key="stats-over-count">{triggerCounts.device[selectedDevice._id].over}</td>
                </tr>,
                <tr key="stats-miss-row">
                    <td key="stats-miss">Miss</td>
                    <td key="stats-miss-count">{triggerCounts.device[selectedDevice._id].miss}</td>
                </tr>,
                <tr key="stats-percentage-row">
                    <td key="stats-percentage">{showSinglePercentage ? 'Single' : 'Hit'} %</td>
                    <td key="stats-trigger-rate">{triggerCounts.device[selectedDevice._id].rate}%</td>
                </tr>,
            ];

            chart = <MatrixBarGraph data={chartData} />;

            let testInstanceDevice = testInstance.devices.find(
                testInstanceDevice => testInstanceDevice.deviceId === selectedDevice._id,
            );

            let osVersion, sdkVersion, model;
            if (testInstanceDevice !== undefined && testInstanceDevice.systemState !== undefined) {
                osVersion = testInstanceDevice.systemState.osVersion;
                sdkVersion = testInstanceDevice.systemState.sdkVersion;
                model = testInstanceDevice.systemState.model;
            }

            return (
                <div className="matrix-analysis-info-panel">
                    <table className="matrix-analysis-device-info-table">
                        <thead />
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{selectedDevice.name}</td>
                            </tr>
                            <tr>
                                <td>API level / OS Version</td>
                                <td>{osVersion}</td>
                            </tr>
                            <tr>
                                <td>SDK Version</td>
                                <td>{sdkVersion}</td>
                            </tr>
                            <tr>
                                <td>Model</td>
                                <td>{model}</td>
                            </tr>
                            {stats}
                        </tbody>
                    </table>
                    {chart}
                </div>
            );
        } else if (selectedZone) {
            const chartData = triggerCounts.zone[selectedZone._id];

            let stats, chart;

            stats = [
                <tr key="stats-single-row">
                    <td key="stats-single">Single</td>
                    <td key="stats-single-count">{chartData.single}</td>
                </tr>,
                <tr key="stats-over-row">
                    <td key="stats-over">Over</td>
                    <td key="stats-over-count">{chartData.over}</td>
                </tr>,
                <tr key="stats-miss-row">
                    <td key="stats-miss">Miss</td>
                    <td key="stats-miss-count">{chartData.miss}</td>
                </tr>,
                <tr key="stats-percentage-row">
                    <td key="stats-percentage">{showSinglePercentage ? 'Single' : 'Hit'} %</td>
                    <td key="stats-trigger-rate">{chartData.rate}%</td>
                </tr>,
            ];

            chart = <MatrixBarGraph data={chartData} />;

            return (
                <div className="matrix-analysis-info-panel">
                    <table className="matrix-analysis-zone-info-table">
                        <thead />
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{selectedZone.name}</td>
                            </tr>
                            {stats}
                        </tbody>
                    </table>
                    {chart}
                </div>
            );
        } else {
            return <div className="matrix-analysis-info-panel">Click a device or zone to view information.</div>;
        }
    }
}

export default MatrixInfoPanel;
